import React from "react";

export const Marquee = ({ items, className = "" }) => {
  const content = [...items, ...items];
  return (
    <div className={`relative overflow-hidden border-y border-navy/15 bg-navy py-5 ${className}`} data-testid="marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {content.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-heading text-2xl md:text-3xl font-black uppercase tracking-tight text-offwhite/90 px-6">
              {item}
            </span>
            <span className="text-gold text-xl" aria-hidden="true">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
